import AboutModal from './AboutModal.json';
import AdvancedFilters from './AdvancedFilters.json';
import Buttons from './Buttons.json';
import CineDialog from './CineDialog.json';
import Common from './Common.json';
import DatePicker from './DatePicker.json';
import Feedback from './Feedback.json';
import Header from './Header.json';
import Invite from './Invite.json';
import Login from './Login.json';
import MeasurementTable from './MeasurementTable.json';
import Messages from './Messages.json';
import NotFound from './NotFound.json';
import ProcessingErrors from './ProcessingErrors.json';
import SidePanel from './SidePanel.json';
import StudyBrowser from './StudyBrowser.json';
import StudyList from './StudyList.json';
import Upload from './Upload.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import ViewportDownloadForm from './ViewportDownloadForm.json';
import Workspaces from './Workspaces.json';

export default {
  es: {
    AboutModal,
    AdvancedFilters,
    Buttons,
    CineDialog,
    Common,
    DatePicker,
    Feedback,
    Header,
    Invite,
    Login,
    MeasurementTable,
    Messages,
    NotFound,
    ProcessingErrors,
    SidePanel,
    StudyBrowser,
    StudyList,
    Upload,
    UserPreferencesModal,
    ViewportDownloadForm,
    Workspaces,
  },
};
